import React from 'react';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonos = [{
    title: '🎁 BONO #1',
    desc: 'Lista imprimible de compras inteligentes'
  }, {
    title: '🎁 BONO #2',
    desc: 'Pack de etiquetas para freezer'
  }, {
    title: '🎁 BONO #3',
    desc: '15 Comidas de Emergencia'
  }];
  return <section className="w-full bg-pink py-16 px-4 flex flex-col items-center" data-id="element-24">
      <div className="max-w-4xl w-full text-center" data-id="element-25">
        <h2 className="text-3xl md:text-4xl font-bold text-brown-800 mb-2" data-id="element-26">
          🎁 BONOS INCLUIDOS HOY
        </h2>
        <p className="text-xl font-bold text-red-500 mb-10 bg-white inline-block px-6 py-2 rounded-full shadow-sm border border-red-100" data-id="element-27">
          🎉 ¡GRATIS por tiempo de lanzamiento!
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-28">
          {bonos.map((bono, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-md border-2 border-pink border-dashed flex flex-col items-center transform hover:scale-105 transition-transform duration-300" data-id="element-29">
              <div className="bg-pink p-4 rounded-full mb-4" data-id="element-30">
                <Gift className="text-red-400" size={40} data-id="element-31" />
              </div>
              <h3 className="text-xl font-bold text-brown-800 mb-3" data-id="element-32">
                {bono.title}
              </h3>
              <p className="text-brown-600 font-medium" data-id="element-33">{bono.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}